import { render } from "./SignUpForm.vue?vue&type=template&id=588921a6&ts=true"
import script from "./SignUpForm.ts?vue&type=script&lang=ts&external"
export * from "./SignUpForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__